import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import type { Testimonial } from '../data/testimonials';
interface TestimonialsProps {
  testimonials: Testimonial[];
  title?: string;
  className?: string;
}
export function Testimonials({
  testimonials,
  title,
  className = ''
}: TestimonialsProps) {
  return <section className={`py-16 bg-navy-900 ${className}`} data-id="element-317" data-mp="3b0ayqdawmxnp">
      <div className="container mx-auto px-4" data-id="element-318" data-mp="36z95cd3o5ftn">
        {title && <h2 className="font-bold text-center mb-12 text-white text-[16px] md:text-2xl" data-id="element-319" data-mp="31zwc9am7fcim">
            {title}
          </h2>}

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-320" data-mp="2x1upaelnqt1v">
          {testimonials.map((t, i) => <motion.div key={t.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-navy-950/80 p-6 rounded-2xl shadow-lg border border-silver/15 flex flex-col h-full" data-id="element-321" data-mp="2s3jh08b0gqlr" data-mpi={i}>
              <div className="flex items-center gap-1 mb-4" aria-label="5 de 5 estrellas" data-id="element-322" data-mp="c6ljhnacztxv">
                {[...Array(5)].map((_, j) => <StarIcon key={j} className="w-4 h-4 text-silver fill-silver" data-id="element-323" data-mp="14vj1dpanroq3" data-mpi={j} />)}
              </div>

              <p className="text-silver italic mb-6 flex-grow" data-id="element-324" data-mp="q7666ujea9wn">"{t.text}"</p>

              <div className="flex items-center gap-3 mt-auto pt-4 border-t border-silver/15" data-id="element-325" data-mp="v5prqtu2tjoh">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center text-white font-bold text-sm shrink-0 ring-1 ring-silver/40 ${t.color}`} aria-hidden="true" data-id="element-326" data-mp="1ivac9h5voozv">
                  {t.initials}
                </div>
                <div data-id="element-327" data-mp="1xfmvrbdxn1vu">
                  <p className="font-bold text-white text-sm" data-id="element-328" data-mp="1sj5xhod0r751">{t.name}</p>
                  <p className="text-xs text-silver-dark" data-id="element-329" data-mp="1sh37337yfbzs">{t.location}</p>
                  {t.pack && <p className="text-xs font-medium text-silver mt-0.5" data-id="element-330" data-mp="1oj5f5smsubsp">
                      {t.pack}
                    </p>}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}